export default `float i,g=.3,e,s=2.,q;
    for(int i=0;i++<7;p=vec3(2.0,5.0,1.0)-abs(abs(abs(p)*e-3.)-vec3(2.0,5.0,1.0)))
      s*=e=12./min(dot(p,p),12.);
    return min(1.,length(p.xz)-.2)/s;
  }`